import { AppDataQueries, AppDataQueryKey, QueryOptions } from '@/lib/app-data';
import { UseQueryResult, useQuery } from 'react-query';

const useAppData = <T>(
  queryKey: AppDataQueryKey,
  options: QueryOptions = {}
): UseQueryResult<T> => {
  const { queryFn, options: defaultOptions } = AppDataQueries.get(queryKey) || {};
  return useQuery([queryKey], queryFn!, { ...defaultOptions, ...options });
};

export default useAppData;
